import { withErrorBoundary } from 'shared'
import { Spinner }           from 'shared'
import { FAIcon }            from 'shared'
import { NoResults }         from 'shared'
import { Backend }           from 'base'
import { TopLevelPage }      from 'ui'
import PaymentCardItem       from './PaymentCardItem'
import { useEffect, useState } from 'react'

const PaymentCardList = () => {
  // State
  const [state, setState] = useState({})

  // Consts

  // Hooks
  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    let { cards } = await Backend.get('/profile/credit_cards')
    if (cards.length == 0) localStorage.rlHasCard = false
    cardsDidUpdate(cards)
  }

  const cardsDidUpdate = (cards) => {
    setState({ cards })
  }

  let { cards } = state
  return (
    <TopLevelPage className="SquarePayment">
      <div className="credit-cards-list">
        {
          document.getElementById('fran-js') ? <NoResults>You're using Fran Payments Gateway! You'll be asked to Enter Credit Card information upon reservation.</NoResults> :
          cards == null ? <Spinner /> :
          cards.length == 0 ? <NoResults>No Credit Cards Saved</NoResults> :
          cards.map(card => <PaymentCardItem key={card.id} card={card} cardsDidUpdate={cardsDidUpdate} />)
        }
      </div>
      <div className="credit-cards-list text-right">
        {
          document.getElementById('square-js') &&
            <Link to="/settings/payment/new" className='btn smart-button'>
              <FAIcon icon='faPlus' /> Add New Card
            </Link>
        }
      </div>
    </TopLevelPage>
  )
}

export default withErrorBoundary(PaymentCardList)
